class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (overlay) overlay.addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    window.addEventListener('popstate', () => { if (this.classList.contains('active')) this.close(); });
    window.addEventListener('pageshow', (evt) => {
      if (evt.persisted) {
        this.close();
        document.querySelectorAll('.vbox-overlay, .vbox-container').forEach((element) => element.remove());
        document.body.classList.remove('vbox-open');
        document.documentElement.classList.remove('vbox-open');
      }
    });
  }
  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => { event.preventDefault(); this.open(cartLink); });
    cartLink.addEventListener('keydown', (event) => { if (event.code.toUpperCase() === 'SPACE') { event.preventDefault(); this.open(cartLink); } });
  }
  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    this.style.removeProperty('visibility');
    this.style.removeProperty('opacity');
    this.style.removeProperty('pointer-events');
    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (overlay) {
      overlay.style.removeProperty('display');
      overlay.style.removeProperty('opacity');
      overlay.style.removeProperty('visibility');
      overlay.style.removeProperty('pointer-events');
    }
    setTimeout(() => { this.classList.add('animate', 'active'); });
    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });
    document.body.classList.add('overflow-hidden');
    document.body.classList.add('mw-mobile-sticky-buy-active-cart-open');
  }
  close() {
    this.classList.remove('active', 'animate');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    document.body.classList.remove('mw-mobile-sticky-buy-active-cart-open');
    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (overlay) {
      overlay.style.setProperty('display', 'none', 'important');
      overlay.style.setProperty('opacity', '0', 'important');
      overlay.style.setProperty('visibility', 'hidden', 'important');
      overlay.style.setProperty('pointer-events', 'none', 'important');
    }
    this.style.setProperty('visibility', 'hidden', 'important');
    this.style.setProperty('opacity', '0', 'important');
    this.style.setProperty('pointer-events', 'none', 'important');
  }
  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');
    if (cartDrawerNote.nextElementSibling.getAttribute('id')) cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    cartDrawerNote.addEventListener('click', (event) => { event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open')); });
    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }
  renderContents(parsedState) {
    document.querySelectorAll('.vbox-overlay, .vbox-container').forEach((element) => element.remove());
    document.body.classList.remove('vbox-open');
    document.documentElement.classList.remove('vbox-open');
    const inner = this.querySelector('.drawer__inner');
    if (inner && inner.classList.contains('is-empty')) inner.classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });
    setTimeout(() => {
      const overlay = this.querySelector('#CartDrawer-Overlay');
      if (overlay) overlay.addEventListener('click', this.close.bind(this));
      this.open();
    });
  }
  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
  getSectionsToRender() {
    return [{ id: 'cart-drawer', selector: '#CartDrawer' }, { id: 'cart-icon-bubble' }];
  }
  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }
  setActiveElement(element) { this.activeElement = element; }
}
customElements.define('cart-drawer', CartDrawer);
class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [{ id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' }, { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' }];
  }
}
customElements.define('cart-drawer-items', CartDrawerItems);